import React from "react";
import Container from "@ui/container";
import ComplexText from "@ui/complex-text";

const SingleItem = ({ item }) => {
    return (
        <p className="first:mt-0 mt-5">
            {item.title && <span className="font-semibold">{item.title}</span>}{" "}
            <ComplexText values={item.text}></ComplexText>
        </p>
    );
};

const TermsConditions = ({ data }) => {
    if (data === null || data.items === null) return null;
    return (
        <div className="text-xs">
            {data.items.map((item, index) => {
                return <SingleItem key={index} item={item} />;
            })}
        </div>
    );
};

export default TermsConditions;
